var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRoundTransferVertical = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2C14.9183 2 18.5 5.58172 18.5 10C18.5 14.4183 14.9183 18 10.5 18C6.08172 18 2.5 14.4183 2.5 10C2.5 5.58172 6.08172 2 10.5 2ZM12.7 14L12.7 7.6L14.0479 9.14452C14.2658 9.39418 14.6449 9.41994 14.8945 9.20205C15.1442 8.98417 15.1699 8.60514 14.9521 8.35548L12.5521 5.60548C12.3876 5.41704 12.1235 5.35038 11.8893 5.4382C11.6551 5.52602 11.5 5.74989 11.5 6L11.5 14C11.5 14.3314 11.7686 14.6 12.1 14.6C12.4314 14.6 12.7 14.3314 12.7 14ZM6.10548 10.7979C6.35514 10.5801 6.73417 10.6058 6.95205 10.8555L8.3 12.4V6C8.3 5.66863 8.56863 5.4 8.9 5.4C9.23137 5.4 9.5 5.66863 9.5 6V14C9.5 14.2501 9.34486 14.474 9.11067 14.5618C8.87649 14.6496 8.6124 14.583 8.44795 14.3945L6.04795 11.6445C5.83006 11.3949 5.85582 11.0158 6.10548 10.7979Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundTransferVertical, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RoundTransferVertical.fc19e895.svg";
export { ForwardRef as ReactComponent };